import script from "./BoardCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./BoardCategory.vue?vue&type=script&lang=ts&setup=true"

import "./BoardCategory.vue?vue&type=style&index=0&id=363e08ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363e08ed"]])

export default __exports__